import { Badge } from "/src/modern/components/ui/badge";
import MySwivuGroupSection from "./MySwivuGroupSection.jsx";
import React from "react";

export function SearchResultsSection({ results, onWorkforceActiveChange }) {
  // Group results by category
  const groupedResults = results.reduce((acc, result) => {
    if (!acc[result.category]) {
      acc[result.category] = [];
    }
    acc[result.category].push(result);
    return acc;
  }, {});

  const renderResults = () => {
    return Object.entries(groupedResults).map(([category, categoryResults]) => {
      // Convert search results back to the format expected by DashboardGroupSection
      const boards = categoryResults.filter(result => result.type === 'board').map(result => result.boardData);
      const templates = categoryResults.filter(result => result.type === 'template').map(result => result.templateData);

      // Create categorizedBoards object for the specific category
      const categorizedBoards = {
        created: category === 'created' ? boards : [],
        invited: category === 'invited' ? boards : []
      };

      return (
        <MySwivuGroupSection
          key={category}
          categorizedBoards={categorizedBoards}
          recentlyViewed={[]} // Not needed for search results
          boardTemplates={templates}
          handleWorkforceChange={onWorkforceActiveChange}
          isSearchMode={true}
          searchCategory={category}
        />
      );
    })
  }

  return (
    <div className="space-y-swivu-base">
      {/* Header */}
      <div className="flex items-center gap-2">
        <i className="fa fa-search text-2xl text-muted-foreground"></i>
        <h2 className="text-2xl font-bold text-foreground">Search Results</h2>
        <Badge variant="secondary" className="text-sm">
          {results.length}
        </Badge>
      </div>

      {/* Render each category using DashboardGroupSection */}
      {renderResults()}
    </div>
  );
}
